import { memo, useMemo } from 'react';

import { PackageEnum } from '../../constants/enum';

import IconCheck from './feature-checked.svg';
import IconUnchecked from './feature-unchecked.svg';
import './version-compare-table.scss';

// 功能列表
const FEATURES = ['港股LV1+港股LV1', '基本功能', '天滙獨家指標', '程式選股', '資金盤路', '期貨盤路', '大戶盤路'];

interface VersionCompareTableProps {
  onPurchase?: (packageType: PackageEnum) => void;
}

export const VersionCompareTable = memo<VersionCompareTableProps>(({ onPurchase }) => {
  const packagesMap = window.GLOBAL_CONFIG?.mobileShop?.packagesMap || {};
  // 版本数据
  const VERSIONS = useMemo(
    () => [
      {
        name: '輕量',
        price: packagesMap[PackageEnum.LITE]?.price,
        code: packagesMap[PackageEnum.LITE]?.code,
        features: [true, true, false, false, false, false, false],
        type: PackageEnum.LITE,
      },
      {
        name: '標準',
        price: packagesMap[PackageEnum.STANDARD]?.price,
        code: packagesMap[PackageEnum.STANDARD]?.code,
        features: [true, true, true, true, false, false, false],
        type: PackageEnum.STANDARD,
      },
      {
        name: '專業',
        price: packagesMap[PackageEnum.PRO]?.price,
        code: packagesMap[PackageEnum.PRO]?.code,
        features: [true, true, true, true, true, true, true],
        type: PackageEnum.PRO,
      },
    ],
    [],
  );

  return (
    <div styleName="container">
      {VERSIONS.map((version) => (
        <div key={version.name} styleName="column">
          <div styleName="header-container">
            {/* 版本名称 */}
            <div styleName="header">{version.name}</div>

            {/* 产品标签 */}
            <div styleName="label">網頁+下載版</div>
          </div>

          {/* 功能列表 */}
          <div styleName="features">
            {FEATURES.map((feature, index) => {
              const isChecked = version.features[index];
              return (
                <div key={feature} styleName="feature">
                  {isChecked ? <IconCheck styleName="checked-icon" /> : <IconUnchecked styleName="unchecked-icon" />}
                  {feature}
                </div>
              );
            })}
          </div>

          {/* 订购按钮 */}
          <div styleName="button-wrapper">
            {/* 价格 */}
            <div styleName="price">
              <div styleName="price-amount">${version.price}</div>
              <div styleName="price-unit">/ 月</div>
            </div>
            <button type="button" styleName="purchase-btn" onClick={() => onPurchase?.(version.type)}>
              立即訂購
            </button>
          </div>
        </div>
      ))}
    </div>
  );
});
